import { render, staticRenderFns } from "./sub-config.vue?vue&type=template&id=31251f02&"
import script from "./sub-config.vue?vue&type=script&lang=js&"
export * from "./sub-config.vue?vue&type=script&lang=js&"
import style0 from "./sub-config.vue?vue&type=style&index=0&id=31251f02&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports